import { render, staticRenderFns } from "./ProductComponent.vue?vue&type=template&id=0e89dd92&scoped=true"
import script from "./ProductComponent.vue?vue&type=script&lang=js"
export * from "./ProductComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e89dd92",
  null
  
)

export default component.exports